﻿import { PublicClientApplication } from '@azure/msal-browser';
import { getToken } from './extensions';

export const downloadBlob = async (
  url: string,
  msalClient: PublicClientApplication,
  mscalScopes: string[],
  defaultFileName: string,
  mimeType: string,
  data?: any,
) => {
  const token = await getToken(msalClient, mscalScopes);
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  var request: RequestInit;
  if (data) {
    request = {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    };
  } else {
    request = {
      headers,
      method: 'GET',
    };
  }

  const response = await fetch(url, request);

  if (response.status !== 200) {
    throw new Error(`Error downloading file from ${url}`);
  }
  const blob = await response.blob();
  const objectUrl = window.URL.createObjectURL(new Blob([blob], { type: mimeType }));
  const link = document.createElement('a');
  link.href = objectUrl;
  link.target = '_blank';

  var fileName;
  const header = response.headers.get('Content-Disposition');
  if (header) {
    const subheader = header.split(';')[1].trim();
    fileName = subheader.startsWith('filename=') ? subheader.slice('filename='.length) : subheader;
  } else {
    fileName = defaultFileName;
  }

  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
};
